// #region imports

// --- HS Code
import * as c from './';

// #endregion

export const accountRoutes = [
  { path: 'register',
    component: c.RegisterShellComponent,
  },
  { path: 'registrationconfirmed/:token',
    component: c.RegistrationConfirmedComponent,
  },
  {
    path: 'book',
    component: c.BookComponent,
  }
];
